import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // userPreferences: Settings visitors can toggle
  // This may not be used
  state: {
    scrollLock: false,
    // UserPreferences
    // Update 3 places in App.vue
    // at var defaultPrefs
    userPreferences: {
      darkMode: false,
      animations: true,
      startPage: '/'
    }
  },
  mutations: {
    scrollLock(state, scrollLock) {
      state.scrollLock = scrollLock
    },
    userPreferences(state, userPreferences) {
      state.userPreferences = userPreferences
    }
  },
  getters: {
    scrollLock: state => state.scrollLock,
    userPreferences: state => state.userPreferences
  }
})
